module.exports = __webpack_public_path__ + "static/media/farmers.c3c2e7fd.webp";